/*
 * Lumina28 state-shipping blocklist guard (Phase 1)
 *
 * Reads each cart line's product.metafields.custom.state_blocklist via the
 * /cart.js endpoint, then intercepts checkout to validate ship-to state.
 *
 * This is a theme-level guard — Phase 1 trade-off. Phase 2 migrates to a
 * Shopify cart_checkout_validations Function (unbypassable, server-side).
 *
 * Spec: docs/superpowers/specs/2026-06-06-lumina28-catalog-expansion-design.md AC-14
 */
(function () {
  'use strict';

  var BLOCKED_STATES_GLOBAL_KEY = 'lumina28_state_block_v1';

  function showBlock(message) {
    var existing = document.getElementById('lumina28-state-block-modal');
    if (existing) existing.remove();
    var modal = document.createElement('div');
    modal.id = 'lumina28-state-block-modal';
    modal.style.cssText =
      'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.6);' +
      'z-index:99999;display:flex;align-items:center;justify-content:center;padding:1rem;';
    var inner = document.createElement('div');
    inner.style.cssText =
      'max-width:480px;background:#fff;padding:1.5rem;border-radius:6px;font-family:inherit;';
    inner.innerHTML =
      '<h3 style="margin-top:0;color:#a30000;">Shipping restricted</h3>' +
      '<p style="margin:0.5rem 0;">' + message + '</p>' +
      '<p style="margin:0.5rem 0;font-size:0.85rem;color:#666;">' +
      'See <a href="/pages/forge-state-laws">forge/state-laws</a> for the full restriction list.' +
      '</p>' +
      '<button id="lumina28-state-block-close" style="margin-top:1rem;padding:0.5rem 1rem;cursor:pointer;">Close</button>';
    modal.appendChild(inner);
    document.body.appendChild(modal);
    document.getElementById('lumina28-state-block-close').addEventListener('click', function () {
      modal.remove();
    });
  }

  function checkCartAgainstState(stateCode, onBlock, onPass) {
    if (!stateCode) { onPass(); return; }
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var checks = (cart.items || []).map(function (item) {
          return fetch('/products/' + item.handle + '.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (p) {
              // Shopify product .js does not expose metafields by default.
              // Fall back to a separate metafield-proxy endpoint when present, else allow.
              // For Phase 1, we annotate metafields server-side into a <script> tag in product
              // template (see product-state-data.liquid).
              var data = window.LUMINA28_PRODUCT_STATE_BLOCKLIST && window.LUMINA28_PRODUCT_STATE_BLOCKLIST[p.id];
              if (!data) return null;
              if (data.blocklist && data.blocklist.indexOf(stateCode) !== -1) {
                return {
                  sku: item.sku,
                  title: item.product_title,
                  state: stateCode,
                  reason: (data.reasons && data.reasons[stateCode]) || 'Restricted in this jurisdiction.',
                };
              }
              return null;
            });
        });
        Promise.all(checks).then(function (results) {
          var blocked = results.filter(function (r) { return r; });
          if (blocked.length) {
            var msg = blocked.map(function (b) {
              return '<strong>' + b.title + '</strong>: ' + b.reason;
            }).join('<br><br>');
            onBlock(msg);
          } else {
            onPass();
          }
        });
      })
      .catch(function () { onPass(); });
  }

  // Hook the checkout button click. Capture phase to intercept before Shopify's handler.
  document.addEventListener('click', function (ev) {
    var target = ev.target;
    if (!target) return;
    var isCheckout =
      (target.name === 'checkout') ||
      (target.id === 'checkout') ||
      (target.getAttribute && target.getAttribute('data-checkout-button') !== null) ||
      (target.closest && target.closest('[name=checkout]'));
    if (!isCheckout) return;

    // Get the state from the most recent ship-to address. In cart page, Shopify may have
    // a shipping calculator with a state field. If not, defer to checkout-side check.
    var stateInput = document.querySelector('select[name="address[province]"], select[name="checkout[shipping_address][province]"]');
    var stateCode = stateInput && stateInput.value;
    if (!stateCode) return;  // No state known yet — let checkout proceed

    ev.preventDefault();
    ev.stopPropagation();
    checkCartAgainstState(stateCode, function (msg) { showBlock(msg); }, function () {
      // Re-fire click without our handler
      target.removeEventListener('click', arguments.callee, true);
      target.click();
    });
  }, true);

  // Expose
  window.lumina28StateBlock = { check: checkCartAgainstState, show: showBlock };
})();
